/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankAccount
 */
export interface BankAccount {
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    iban: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    bic: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    bankName: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    accountHolder: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccount
     */
    sepa: boolean;
}

/**
 * Check if a given object implements the BankAccount interface.
 */
export function instanceOfBankAccount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "iban" in value;
    isInstance = isInstance && "bic" in value;
    isInstance = isInstance && "bankName" in value;
    isInstance = isInstance && "accountHolder" in value;
    isInstance = isInstance && "sepa" in value;

    return isInstance;
}

export function BankAccountFromJSON(json: any): BankAccount {
    return BankAccountFromJSONTyped(json, false);
}

export function BankAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iban': json['iban'],
        'bic': json['bic'],
        'bankName': json['bankName'],
        'accountHolder': json['accountHolder'],
        'sepa': json['sepa'],
    };
}

export function BankAccountToJSON(value?: BankAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iban': value.iban,
        'bic': value.bic,
        'bankName': value.bankName,
        'accountHolder': value.accountHolder,
        'sepa': value.sepa,
    };
}

